import React from 'react';
import SVGInline from "react-svg-inline";

import Add from 'icons/actions/add';
import Remove from 'icons/actions/remove';
import Checkmark from 'icons/actions/checkmark';

import styles from './item-icon.scss';

const icon = {
  check: <SVGInline svg={`${Checkmark}`} className={`${styles.svg} ${styles.check}`} />,
  minus: <SVGInline svg={`${Remove}`} className={`${styles.svg} ${styles.remove}`} />,
  plus: <SVGInline svg={`${Add}`} className={`${styles.svg} ${styles.add}`} />,
};

const ItemIcon = ({symbol}) => {
  return (
    icon[symbol]
  );
};

ItemIcon.propTypes = {symbol: React.PropTypes.string};


export default ItemIcon;



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-list/toggle-item-button/item-icon.jsx